import { Component, ElementRef, Renderer2, ViewChild, EventEmitter, Output, input, inject, computed } from '@angular/core';
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'edit-avatar,[edit-avatar]',
    template: `
    <a *ngIf="editOption()" class="edit-avatar" (click)="onClick()">
    <i  class="material-icons edit"></i>Edit</a>
    <input type="file"  #input  (change)="onChange($event)" accept=".jpeg,.jpg,.png" style="display: none;" />
    <a  *ngIf="flag()" class="delete-avatar" (click)="delete()">
    <i class="material-icons cancel" style="font-size:20px;"></i></a>
    `,
    standalone: false
})
export class EditAvatarComponent {

  @ViewChild('input', { static: true }) inputElRef: ElementRef;
  change = new EventEmitter<any>();
  @Output() deleteImg = new EventEmitter();
  flag = input<boolean>();
  isEdit = input<number | object | undefined>(0);
  // computed, not effect-in-ngOnInit: effect() needs an injection context
  // (calling it from a lifecycle hook throws NG0203).
  editOption = computed(() => {
    const isEdit = this.isEdit();
    return isEdit === 0
      || isEdit === undefined
      || typeof isEdit === 'object';
  });
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  delete() {
    this.deleteImg.emit();
  }
  onClick() {
    const elem = this.inputElRef.nativeElement;
    const evt = new MouseEvent('click', { bubbles: true });
    elem.dispatchEvent(evt);
  }

  onChange(event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      const parentNode = this.renderer.parentNode(this.el.nativeElement);
      this.renderer.setValue(parentNode.children[0], input.files[0].name);
      this.change.emit(event);
    }
  }

}
